import { useState } from "react";
import CalendarView from "./CalendarView";
import { Header } from "./Header";
import { LoadingProgress } from "./LoadingProgress";

export function FilmRevival () {

  const [isLoading, setIsLoading ] = useState(false);

  return (
    <>
      <Header />
      <CalendarView isLoading={isLoading} setIsLoading={setIsLoading} />
      {isLoading && <LoadingProgress />}
    </>
  )
}